export default "__VITE_ASSET__BPM5CvKc__"